import {
  // No v2 per-group optional-files route exists yet; keep this v1 read.
  getOptionalFilesDependentsTicketGroup,
  ticketGroupService
} from '../../../../network';

import {
  SET_MASSIVE_DEPENDENTS_INCORPORATION_URL,
  FETCH_MASSIVE_DEPENDENTS_INCORPORATION_URL,
  GET_MASSIVE_DEPENDENTS_INCORPORATION_URL,
  POST_FILE_DEPENDENTS_INCORPORATION,
  POST_MASSIVE_FORM_DEPENDENTS_INCORPORATION,
  POST_NO_DELIVERABLE_DEPENDENTS_INCORPORATION,
  SET_OPTIONAL_FILES_DEPENDENTS_TICKET_GROUP,
  FETCH_OPTIONAL_FILES_DEPENDENTS_TICKET_GROUP,
  GET_OPTIONAL_FILES_DEPENDENTS_TICKET_GROUP
} from './types';

const store = {};

const getDefaultState = () => ({
  tickets: [],
  altaIndividual: [],
  companies: [],
  insurances: [],
  docs: [],
  form: {},
  url: '',
  ticketDetail: {},
  ticketDetailFile: {},
  dependentsUrl: '',
  optionalFiles: {}
});

store.state = getDefaultState();

store.getters = {
  [GET_OPTIONAL_FILES_DEPENDENTS_TICKET_GROUP]: (state) => state.optionalFiles,
  [GET_MASSIVE_DEPENDENTS_INCORPORATION_URL]: (state) => state.dependentsUrl
};

store.mutations = {
  [SET_MASSIVE_DEPENDENTS_INCORPORATION_URL](state, payload) {
    state.dependentsUrl = payload;
  },
  [SET_OPTIONAL_FILES_DEPENDENTS_TICKET_GROUP](state, payload) {
    state.optionalFiles = payload;
  }
};

store.actions = {
  async [FETCH_MASSIVE_DEPENDENTS_INCORPORATION_URL]({ commit }, payload) {
    const url = ticketGroupService.getDependentsIncorporationFormatUrl(
      payload.companyId,
      payload.insuranceCompanyId,
      payload.typeForm
    );
    commit(SET_MASSIVE_DEPENDENTS_INCORPORATION_URL, url);
    return url;
  },

  async [POST_FILE_DEPENDENTS_INCORPORATION](_, payload) {
    try {
      return await ticketGroupService.createDependentsIncorporationFile(
        payload
      );
    } catch (error) {
      console.error('Error en POST_FILE_DEPENDENTS_INCORPORATION:', error);
      throw error;
    }
  },
  async [FETCH_OPTIONAL_FILES_DEPENDENTS_TICKET_GROUP](
    { commit },
    ticketGroupId
  ) {
    try {
      const response =
        await getOptionalFilesDependentsTicketGroup(ticketGroupId);
      if (response && (response.status === 201 || response.status === 200)) {
        commit(SET_OPTIONAL_FILES_DEPENDENTS_TICKET_GROUP, response.data);
      }
    } catch (error) {
      console.error(
        'Error al obtener los archivos opcionales del ticket. FETCH_OPTIONAL_FILES_DEPENDENTS_TICKET_GROUP:',
        error.response.data.message
      );
      throw error.response.data.message;
    }
  },

  async [POST_MASSIVE_FORM_DEPENDENTS_INCORPORATION](_, payload) {
    try {
      return await ticketGroupService.createDependentsIncorporationForm(
        payload
      );
    } catch (error) {
      console.error(
        'Error en POST_MASSIVE_FORM_DEPENDENTS_INCORPORATION:',
        error
      );
      throw error;
    }
  },

  async [POST_NO_DELIVERABLE_DEPENDENTS_INCORPORATION](_, payload) {
    try {
      return await ticketGroupService.createDependentsIncorporationNoDeliverable(
        payload
      );
    } catch (error) {
      console.error(
        'Error en POST_NO_DELIVERABLE_DEPENDENTS_INCORPORATION:',
        error
      );
      throw error;
    }
  }
};

export default store;
